// extracted by mini-css-extract-plugin
export var HotspotImage__HeaderGroup = "ImageWithHotspot-module--HotspotImage__HeaderGroup--2pX7B";